document.addEventListener('DOMContentLoaded', () => {
    const productForm = document.querySelector('form[action="/cart/add"]');

    if (productForm && document.body.classList.contains('template-product')) {
        productForm.addEventListener('submit', function(e) {
            // 1. Locate the active Appstle option container
            const activeOption = document.querySelector('.appstle-active-option');
            
            if (activeOption) {
                // 2. Check if there is a selling_plan input inside the ACTIVE container
                const sellingPlanInput = activeOption.querySelector('[name="selling_plan"]');
                const sellingPlanValue = sellingPlanInput ? sellingPlanInput.value : "";

                // 3. Only proceed if a valid subscription plan ID is found
                if (sellingPlanValue && sellingPlanValue.trim() !== "") {
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            items: [{ 
                                id: 51575745347891, // Your Free Product Variant ID
                                quantity: 1 
                            }]
                        })
                    })
                    .then(response => console.log('Subscription detected: Free gift added.'))
                    .catch(error => console.error('Error adding gift:', error));
                }
            }
        });
    }
});
